/**
 * Deliervy methods types
 */
export enum DeliveryMethodsType {
  COLLECTION = 'collection',
  MAIL_ORDER = 'mailOrder',
  MOBILE_TICKET = 'mobileTicket',
  PRINT_AT_HOME = 'printAtHome',
}
